import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, message, Divider} from "antd";
import PropTypes from "prop-types";
import { getSaturday, getNextMonday } from "../../utils/dateUtil";
import { req_add_pim_swap_log } from "../../api";
import { _uuid } from "../../utils/dataUtil";
import PicturesWall from "./pictures-wall";
import "./pictures-wall.css";
class SwapLogAddModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };
  state = {
    lock: false,
    reason: "",
    starttime: "0800",
    endtime: "1700",
    swapDateA: getSaturday(),
    swapDateB: getNextMonday(),
    row: {
      Uid: "",
      ClockType: "FLEXIBLE",
      StaffCode: this.props.user.userCode,
      SwapDateA: "",
      SwapWorkStatusA: "WORK",
      SwapDateB: "",
      SwapWorkStatusB: "PASS",
      StartTime: "0800",
      EndTime: "1700",
      SwapReason: "平假日調換",
      ApplyStatus: "APPLY",
      RecordCreatorCode: this.props.user.userCode,
      RecordDescription: "",
      ReasonFileUrl: "",
    },
  };

  constructor(props) {
    super(props);
    this.get_swap_images = React.createRef();
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_add_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_swap_log(item, token);
    return result.status;
  };

  // 檢核樣式 //////////////////////////////////////////////
  checkWeekend = (dateString) => {
    // 將輸入的字符串轉換為日期物件
    const date = new Date(
      dateString.slice(0, 4),
      parseInt(dateString.slice(4, 6)) - 1,
      dateString.slice(6, 8)
    );

    // 檢查日期是否為六日
    const day = date.getDay();
    if (day === 6 || day === 0) {
      return true;
    } else {
      return false;
    }
  };

  checkTime = (starttime, endtime) => {
    // 檢查輸入是否為四位數字
    if (!this.validateInput(starttime) || !this.validateInput(endtime)) {
      message.error("請輸入四位數字的時間格式，例如0800");
      return false;
    }

    // 將輸入轉換為時間格式
    const startTime = parseInt(starttime.slice(0, 2));
    const startMinute = parseInt(starttime.slice(2, 4));
    const endTime = parseInt(endtime.slice(0, 2));
    const endMinute = parseInt(endtime.slice(2, 4));

    // 檢查時間是否有效
    if (
      !this.isValidTime(startTime, startMinute) ||
      !this.isValidTime(endTime, endMinute)
    ) {
      alert("時間格式錯誤，請確保時間在00:00至23:59之間");
      return false;
    }

    // 檢查起始時間是否早於結束時間
    if (
      !this.isStartTimeBeforeEndTime(startTime, startMinute, endTime, endMinute)
    ) {
      alert("起始時間不能晚於結束時間");
      return false;
    }
    return true;
  };

  validateInput = (input) => {
    return /^\d{4}$/.test(input);
  };

  // 驗證時間是否有效
  isValidTime = (hour, minute) => {
    return hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59;
  };

  // 檢查起始時間是否早於結束時間
  isStartTimeBeforeEndTime = (startHour, startMinute, endHour, endMinute) => {
    if (startHour < endHour) return true;
    if (startHour === endHour && startMinute < endMinute) return true;
    return false;
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_btn_event = (tag, item) => {
    const { reason, swapDateA, swapDateB, starttime, endtime, row } =
      this.state;
    switch (tag) {
      case "SwapApply":
        if (reason.length === 0) {
          message.error("請輸入平假日調換原因");
          return;
        }
        if (swapDateA !== "" && swapDateB !== "") {
          // if (this.checkWeekend(swapDateA) && !this.checkWeekend(swapDateB)) {
          if (this.checkTime(starttime, endtime)) {
            row.Uid = _uuid();
            row.SwapDateA = swapDateA;
            row.SwapDateB = swapDateB;
            row.StartTime = starttime;
            row.EndTime = endtime;
            row.RecordDescription = reason;

            const reasonFile = this.get_swap_images.current.output_files();
            if (typeof reasonFile[0] === "undefined") {
              message.error("尚未上傳佐證資料");
            } else {
              if (reasonFile[0].indexOf("rc-upload") !== -1) {
                message.error("資料驗證失敗，請重傳");
              } else {
                row.ReasonFileUrl = reasonFile[0];
                //console.log(row); //row
                this.setState({ lock: true });
                this.api_add_item(row).then((result) => {
                  if (result === "success") {
                    message.success("申請調換班成功");
                    this.setState({ lock: true });
                  } else {
                    message.error("申請調換班失敗");
                    this.setState({ lock: false });
                  }
                });
              }
            }
          }
          // } else {
          //   message.error("請先輸入周六日日期，再輸入平日日期");
          // }
        } else {
          message.error("請輸入正確日期");
        }

        break;
      default:
    }
  };

  onDateAChange = (date, dateString) => {
    this.setState({ swapDateA: dateString });
  };
  onDateBChange = (date, dateString) => {
    this.setState({ swapDateB: dateString });
  };

  disabledDate = (current) => {
    // moment().day()：0=週日, 1=週一, ..., 6=週六
    const day = current.day();
    return day !== 0 && day !== 6; // 只允許週六(6)和週日(0)
  };

  render() {
    const ReasonFileUrl = [];
    const fileUrlPath = "/api/UploadFile/AddInsideMediaFile";
    const { data } = this.props;
    const { starttime, endtime, reason, lock, swapDateA, swapDateB } =
      this.state;
    return (
      <>
        <Divider
          orientation="left"
          size="small"
          style={{ borderColor: "#7cb305" }}
          plain
        >
          <i className="fas fa-calendar-day"></i> 1.申請調換日期
        </Divider>
        <Input
          addonBefore="欲出勤休假日"
          placeholder="請輸入欲上班之休假日日期"
          value={swapDateA}
          onChange={(e) => this.setState({ swapDateA: e.target.value })}
        ></Input>
        <Input
          addonBefore="擬補休上班日"
          placeholder="請輸入欲換休之工作日日期"
          value={swapDateB}
          onChange={(e) => this.setState({ swapDateB: e.target.value })}
        ></Input>
        <Divider
          orientation="left"
          size="small"
          style={{ borderColor: "#7cb305" }}
          plain
        >
          <i className="fas fa-clock"></i> 2.設定出勤時間
        </Divider>
        <Input
          addonBefore="出勤日起始時間"
          placeholder="工作起始時間"
          value={starttime}
          onChange={(e) => this.setState({ starttime: e.target.value })}
        ></Input>
        <Input
          addonBefore="出勤日結束時間"
          placeholder="工作結束時間"
          value={endtime}
          onChange={(e) => this.setState({ endtime: e.target.value })}
        ></Input>
        <Divider style={{ margin: "5px 0px", height: "1px" }} plain></Divider>
        <Input
          placeholder="請輸入調換原由"
          value={reason}
          onChange={(e) => this.setState({ reason: e.target.value })}
        ></Input>
        <PicturesWall
          ref={this.get_swap_images}
          images_source={ReasonFileUrl}
          api_url={fileUrlPath}
          self_filename="原由佐證圖檔"
        ></PicturesWall>
        <button
          className="btn btn-info btn-sm"
          style={{ width: "100%" }}
          onClick={() => this.handle_btn_event("SwapApply", data)}
          disabled={lock}
        >
          <i class="fas fa-user-clock" style={{ marginRight: "5px" }}></i>{" "}
          申請調換
        </button>
      </>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(SwapLogAddModal);
